import { NavigationRoute } from 'views/Dashboard/routes';
import { jobTypeDomain } from 'models';
import EditJobTypeView from './EditJobType';

const jobsRoutes = (): NavigationRoute[] => [
  {
    to: `/dashboard/${jobTypeDomain.urlPath}/:id/edit`,
    component: EditJobTypeView
  }
];

export default jobsRoutes;
